/**
 * THE WEB-STORE THEMES, IN ONE PLACE.
 *
 * There used to be two lists: `Context/ThemeContext` knew nine, and
 * `Pages/Shop` kept its own six that predated `lime`, `forest` and `bronze`.
 * The Shop page checks its list before writing `data-theme`, so a salon on any
 * of the three missing themes had it silently dropped and its shop rendered in
 * the default — Heal Skin Clinic is bronze, which is why its brand never
 * showed. A list written down twice is a list that goes stale once.
 *
 * Every theme here has a matching `[data-theme="…"]` block in index.css, and a
 * test asserts that both ways round.
 */
export const WEB_STORE_THEMES = [
  'original',
  'classic',
  'purple',
  'deepPurple',
  'pink',
  'blue',
  'lime',
  'forest',
  'bronze',
  'navy',
];

/** Is this a theme the store can actually render? */
export function isWebStoreTheme(theme) {
  return typeof theme === 'string' && WEB_STORE_THEMES.includes(theme);
}

/**
 * Put the business's theme on the document. Takes a theme name or a business
 * record (`{ webStoreTheme }`); a theme the stylesheet does not define leaves
 * the document as it was. Returns whether it was applied.
 */
export function applyWebStoreTheme(themeOrSalon) {
  const theme = themeOrSalon && typeof themeOrSalon === 'object' ? themeOrSalon.webStoreTheme : themeOrSalon;
  if (!isWebStoreTheme(theme) || typeof document === 'undefined') return false;
  document.documentElement.setAttribute('data-theme', theme);
  return true;
}

export default WEB_STORE_THEMES;
